import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }) => ({
  filterActive: {
    color: palette.green.main,
  },
}));
